
import { AppActions } from "../../types";
import { GET_LEAD, RESET_LEAD_DATA, SET_LEAD_DATA } from "types/actions/leadMaster.action";
import { LeadMasterData } from "types/models/leadMaster/LeadMasterApp";
export enum VIEW_TYPE {
  LIST = 1,
  GRID = 2,
}

const initialState: {
  currentLead: LeadMasterData | null;
  lead: LeadMasterData[];
  leadCount: number;
 
} = {
  currentLead: null,
  lead: [],
  leadCount: 0,
  
};

const LeadMaster = (state = initialState, action: AppActions) => {
  switch (action.type) {
    case GET_LEAD:
      return {
        ...state,
        lead: action.payload.data,
        leadCount: action.payload.total,
      };
    case SET_LEAD_DATA:
      return {
        ...state,
        currentLead: action.payload,
      };
      case RESET_LEAD_DATA:
        return { ...state, currentLead: null };
    default:
      return state; 
  }
};

export default LeadMaster;
